import { Injectable } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { MessageRoutesAPI } from '../constants';
import { FileDownload, MessageCount, MessageVO } from '../interfaces';

import { BaseService } from './BaseService';

@Injectable({})
export class MessagesService extends BaseService {

  static find(id: string | number): Promise<MessageVO> {
    return this.get(MessageRoutesAPI.MESSAGE_ITEM, { id }).then(response => {
      return response.body as MessageVO;
    });
  }

  static count(): Promise<MessageCount> {
    return this.get(MessageRoutesAPI.COUNT_MESSAGE, {}).then(response => {
      return response.body as MessageCount;
    });
  }

  static update(id: string | number): Promise<boolean> {
    return this.put(MessageRoutesAPI.MESSAGE_ITEM, { id })
      .then(response => {
        return response.status === 204;
      });
  }

  static downloadFile(id: string | number, fileId: string | number): Promise<FileDownload> {
    return HttpService.get(MessageRoutesAPI.MESSAGE_FILE,
      { id, fileId })
      .then(response => {
        return response.body as FileDownload;
      });
  }

}
